import gql from 'graphql-tag';

export const FRAGMENT_MINKABU_ANALYSIS = gql`
  fragment minkabuAnalysis on MinkabuAnalysis {
    rating
    targetPrice
    latestTradePrice
  }
`;
